import { snakeCase } from 'lodash';

export const URLS = {
  APPSTORE: 'https://r.2go.com/SPhN16Y1',
  INVOICE2GO: 'https://invoice.2go.com/',
  INVOICE2GO_FEATURES:
    'https://invoice.2go.com/invoice-billing-features-small-business/',
  LOGIN: 'https://account.2go.com/',
  MULTIPLE_CURRENCIES: 'https://support.2go.com/hc/articles/115000630632',
  PRIVACY_POLICY: 'https://invoice.2go.com/privacyInline/',
  PAYMENTS_HELP_ACTIVATE: 'https://support.2go.com/hc/articles/217786928',
  PAYMENTS_HELP_CANCELED: 'https://support.2go.com/hc/articles/218364077',
  PAYMENTS_HELP_FAQ: 'https://support.2go.com/hc/sections/203661277',
  PAYMENTS_HELP_FEE_TIERING: 'https://support.2go.com/hc/articles/115000272931',
  PAYMENTS_HELP_FPT: 'https://support.2go.com/hc/articles/220440447',
  PAYMENTS_HELP_PAYPAL: 'https://support.2go.com/hc/sections/207447407',
  PAYMENTS_HELP_REMINDERS: 'https://support.2go.com/hc/sections/205278287',
  PAYMENTS_STRIPE_DASHBOARD: 'https://dashboard.stripe.com/transfers/overview',
  SUPPORT: 'https://support.2go.com/hc/',
  SUPPORT_REQUESTS: 'https://support.2go.com/hc/requests/new',
  TERMS_OF_SERVICE: 'https://invoice.2go.com/tosInline/',
};

const SUPPORT_2GO_LOCALES = {
  DE_DE: 'de',
  EN_AU: 'en-au',
  EN_CA: 'en-ca',
  EN_GB: 'en-gb',
  EN_US: 'en-us',
  ES_MX: 'es',
  ES_ES: 'es',
  FR_CA: 'fr',
  FR_FR: 'fr',
  IT_IT: 'it',
  NL_NL: 'nl',
};

export function supportUrlsLocalized(url: string, locale: string): string {
  const supportSuffixLocale =
    SUPPORT_2GO_LOCALES[snakeCase(locale).toUpperCase()];

  return !!supportSuffixLocale
    ? url.split('hc').join(`hc/${supportSuffixLocale}`)
    : url;
}
